<template>
    <Modal v-model:visible="visible" :backdrop="true">
        <template v-slot:header>
            <div>
                <h2 class="text-2xl font-bold">{{ Title }}</h2>
            </div>
        </template>
        <template v-slot:main>
            <Alert v-show="alert_error" class="bg-next-orange">{{ alert_error }}</Alert>
            <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 mt-3">
                <div class="flex flex-col">
                    <Field field_name="Azienda del gruppo" :required="!aziendeGruppoAutocomplete?.selection"
                           :errors="getErrors('azienda_gruppo_id')"
                           placeholder="Azienda del gruppo">
                        <VueMultiselect @search-change="aziendeGruppoAutocomplete.search"
                                        :loading="aziendeGruppoAutocomplete.isLoading"
                                        :options="aziendeGruppoAutocomplete.options"
                                        v-model="aziendeGruppoAutocomplete.selection"
                                        track-by="id" label="nome"
                                        class="next-vue-multiselect-single"
                                        :searchable="true"
                                        placeholder="Azienda del gruppo"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Evento promo"
                           :errors="getErrors('promo')">
                        <Select v-model="progetto_model.promo"></Select>
                    </Field>
                </div>
                <div class="flex flex-col lg:col-span-2 xl:col-span-1 gap-6 row-span-5">
                    <div class="flex flex-col grow">
                        <Field field_name="Note" :errors="getErrors('note')" placeholder="Note">
                        <textarea v-model="progetto_model.note" class="p-2 bg-next-gray-md-dark hover:bg-white h-full"
                                  placeholder="Note"/>
                        </Field>
                    </div>
                </div>

                <div class="flex flex-col lg:col-span-2">
                    <Field field_name="Cliente" :required="!clienteAutocomplete?.selection"
                           :errors="getErrors('cliente_id')"
                           placeholder="Cliente">
                        <VueMultiselect @search-change="clienteAutocomplete.search"
                                        :loading="clienteAutocomplete.isLoading"
                                        :options="clienteAutocomplete.options"
                                        v-model="clienteAutocomplete.selection"
                                        track-by="id" label="denominazione"
                                        class="next-vue-multiselect-single"
                                        placeholder="Cliente"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:singleLabel="{option}">
                                {{ `${option.denominazione} - ${option.ragione_sociale}` }}
                            </template>
                            <template v-slot:option="{option}">{{
                                    `${option.denominazione} - ${option.ragione_sociale}`
                                }}
                            </template>
                        </VueMultiselect>
                        <template #help>
                            <span class="pt-1 text-next-dark-gray text-xs">Azienda alla quale si fattura</span>
                        </template>
                    </Field>
                </div>
                <div class="flex flex-col lg:col-span-2">
                    <Field field_name="Committente" :required="!committenteAutocomplete?.selection"
                           :errors="getErrors('committente_id')"
                           placeholder="Committente">
                        <VueMultiselect @search-change="committenteAutocomplete.search"
                                        :loading="committenteAutocomplete.isLoading"
                                        :options="committenteAutocomplete.options"
                                        v-model="committenteAutocomplete.selection"
                                        track-by="id" label="denominazione"
                                        class="next-vue-multiselect-single"
                                        placeholder="Committente"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:singleLabel="{option}">
                                {{ `${option.denominazione} - ${option.ragione_sociale}` }}
                            </template>
                            <template v-slot:option="{option}">{{
                                    `${option.denominazione} - ${option.ragione_sociale}`
                                }}
                            </template>
                        </VueMultiselect>
                        <template #help>
                            <span
                                class="pt-1 text-next-dark-gray text-xs">Azienda per la quale si svolge il lavoro</span>
                        </template>
                    </Field>
                </div>

                <div class="flex flex-col col-span-2">
                    <Field field_name="Titolo" :required="!progetto_model?.titolo?.length" :errors="getErrors('titolo')"
                           v-model="progetto_model.titolo" placeholder="Nome del progetto">
                    </Field>
                </div>

                <div class="flex flex-col col-span-2">
                    <Field field_name="Descrizione" :errors="getErrors('descrizione')"
                           v-model="progetto_model.descrizione" placeholder="Descrizione">
                    </Field>
                </div>

<!--                <div class="flex flex-col">-->
<!--                    <Field field_name="&nbsp" :errors="getErrors('new_business')">-->
<!--                        <Checkbox-->
<!--                            checkClass="h-4 w-4"-->
<!--                            :checked="progetto_model.new_business"-->
<!--                            @change="progetto_model.new_business = $event.target.checked"-->
<!--                        >-->
<!--                            Progetto New Business-->
<!--                        </Checkbox>-->
<!--                    </Field>-->
<!--                </div>-->

                <div class="flex flex-col">
                    <Field field_name="Contatto cliente" :required="false" :errors="getErrors('contatto_cliente')">
                        <VueMultiselect v-model="contattiAutocomplete.selection"
                                        :options="contattiAutocomplete.options"
                                        :multiple="true"
                                        @search-change="searchContatti"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        placeholder="Contatto cliente"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        class="next-vue-multiselect"
                                        track-by="id"
                                        label="full_name">
                            <template v-slot:noResult>
                                <span v-show="clienteAutocomplete.selection">Nessun elemento trovato.</span>
                                <span
                                    v-show="!clienteAutocomplete.selection">Devi scegliere prima un cliente.</span>
                            </template>
                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">
                                    {{ option.full_name }}
                                    <!--                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">-->
                                    <!--                                        <span>{{ option.full_name }}</span>-->
                                    <!--                                    </span>-->
                                </MultiselectOption>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Data inizio" :required="!progetto_model?.data_inizio"
                           :errors="getErrors('data_inizio')"
                           :input-attrs="{max: progetto_model.data_fine}"
                           placeholder="Data inizio" type="date" v-model="progetto_model.data_inizio">
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Data di fine" :required="!progetto_model?.data_fine"
                           :errors="getErrors('data_fine')"
                           :input-attrs="{min: progetto_model.data_inizio}"
                           placeholder="Data di fine" type="date" v-model="progetto_model.data_fine">
                    </Field>
                </div>
                <div class="flex flex-col justify-end lg:col-span-1">
                    <Field field_name="&nbsp;" :errors="getErrors('assets')">
                        <FileUpload
                            v-model:uploaded_files="uploaded_files"
                            v-model:model_files="sottoprogettoFiles"
                            v-model:to_delete="to_delete"
                            multiple
                            accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                        >
                            <template v-slot:default="{props, methods}">
                                <div class="flex flex-col grow">
                                    <NextButton variant="outline-secondary" @click="methods.open"
                                                class="w-full h-10 px-4 grow">
                                        <i class="icon icon-graffetta"></i> Allega
                                    </NextButton>
                                    <div class="grid grid-cols-1 gap-3">
                                        <a class="underline text-sm text-next-atp pt-3"
                                           v-for="(f,idx) in sottoprogettoFiles">
                                            <span>{{ f.name }}</span>
                                            <i v-if="!$attrs.readonly"
                                               class="icon icon-x ml-1"
                                               @click="methods.remove(sottoprogettoFiles, idx)"></i>
                                        </a>

                                        <a class="underline text-sm text-next-atp pt-3"
                                           v-for="(f,idx) in props.to_upload">
                                            <span>{{ f.name }}</span>
                                            <i v-if="!$attrs.readonly"
                                               class="icon icon-x ml-1"
                                               @click="methods.remove(props.to_upload, idx)"></i>
                                        </a>

                                        <a class="underline text-sm text-next-atp pt-3"
                                           v-for="(f,idx) in uploaded_files">
                                            <span>{{ f.name }}</span>
                                            <i v-if="!$attrs.readonly"
                                               class="icon icon-x ml-1"
                                               @click="methods.remove(uploaded_files, idx)"></i>
                                        </a>
                                    </div>
                                </div>
                            </template>
                        </FileUpload>
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Budget di apertura" :required="!progetto_model?.budget"
                           :errors="getErrors('budget')"
                           v-model="progetto_model.budget" placeholder="Budget" type="number"
                           :input-attrs="{step:0.01}">
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Budget presunto/da cliente"
                           :required="!progetto_model?.budget_presunto?.toString()"
                           :errors="getErrors('budget_presunto')"
                           placeholder="Budget presunto/da cliente">
                        <Select :options="[{id: false, text: 'Da cliente'}, {id: true, text: 'Presunto'}]"
                                v-model="progetto_model.budget_presunto"></Select>
                    </Field>
                </div>


                <div class="lg:col-span-2 xl:col-span-1 gap-6 xl:col-start-3">

                    <div class="flex items-end justify-end gap-3">
                        <NextButton variant="outline-secondary"
                                    @click="close"
                                    class="px-4 xl:grow h-10">
                            Chiudi
                        </NextButton>
                        <NextButton variant="primary" @click="creaProgetto" :disabled="loading" :loading="loading"
                                    class="px-4 xl:grow h-10 flex items-center justify-center">
                            <Spinner v-show="$attrs['loading']" class="w-4 h-4 mr-4"></Spinner>
                            {{ create ? 'Aggiungi' : 'Modifica' }}
                        </NextButton>
                    </div>
                </div>
            </div>

        </template>
    </Modal>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import progettiManager from "../api/Progetti";
import FileUpload from "@/components/FileUpload.vue";
import Autocomplete from "@/setup/Autocomplete";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import NextButton from "@/components/NextButton.vue";
import Field from "@/components/Field.vue";
import {mapGetters} from 'vuex';
import {aziendeGruppoManager} from "../api/AziendeGruppo";
import clientiManager from "../api/Clienti";
import contattiManager from "../api/Contatti";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Select from "@/components/Select.vue";
import Alert from "@/components/Alert.vue";
import Spinner from "@/components/Spinner.vue";
import Checkbox from "@/components/Checkbox.vue";

@Options({
    name: 'ModalProgetto',
    components: {
        Checkbox,
        Spinner,
        Alert,
        Select,
        Field,
        FileUpload,
        Modal,
        NextButton,
        MultiselectOption
    },
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        id: {
            type: [Number, String],
            default: 0
        },
        create: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters('aziendeGruppoModule', [])
    }
})
export default class ModalProgetto extends Vue {
    clienteAutocomplete: any = setup(() => Autocomplete(clientiManager))
    committenteAutocomplete: any = setup(() => Autocomplete(clientiManager))
    contattiAutocomplete: any = setup(() => Autocomplete(contattiManager, true))
    aziendeGruppoAutocomplete: any = setup(() => Autocomplete(aziendeGruppoManager))

    id!: number | string
    visible!: boolean
    create!: boolean
    loading = false
    promo_model = false
    alert_error = ''

    uploaded_files: any[] = []
    sottoprogettoFiles: any[] = []
    to_delete: number[] = []

    progetto_model: any = {
        promo: false,
        titolo: null,
        id: null,
        descrizione: null,
        cliente_id: null,
        committente_id: null,
        azienda_gruppo_id: null,
        data_inizio: null,
        data_fine: null,
        budget: null,
        budget_presunto: null,
        note: null,
        brief_files: [],
        contatto_cliente: []
    }

    searchContatti(search: string) {
        if (this.progetto_model.cliente_id) {
            return this.contattiAutocomplete.search(search, 0, {cliente: this.progetto_model.cliente_id})
        }
    }

    created() {
        this.clienteAutocomplete.addAjaxParam('gamma', 1)
        this.committenteAutocomplete.addAjaxParam('gamma', 1)
        this.aziendeGruppoAutocomplete.search()
    }

    get Title() {
        return ''
        // if (this.id) {
        //     return 'Modifica progetto'
        // }
        // return 'Nuovo progetto'
    }

    @Watch('clienteAutocomplete.selection')
    azienda(new_value: any, old: any) {
        this.progetto_model.cliente_id = new_value?.id || new_value
        if (!this.loading && new_value !== old) {
            this.contattiAutocomplete.empty()
        }
        if (!this.progetto_model.committente_id) {
            this.committenteAutocomplete.options = this.clienteAutocomplete.options
            this.committenteAutocomplete.selection = this.clienteAutocomplete.selection
        }
    }

    @Watch('contattiAutocomplete.selection')
    contatti(new_value: any, old: any) {
        this.progetto_model.contatto_cliente = new_value.map((e: any) => e.id)
    }

    @Watch('committenteAutocomplete.selection')
    committente(new_value: any, old: any) {
        this.progetto_model.committente_id = new_value?.id || new_value
    }

    @Watch('progetto_model.data_inizio')
    dataInizio(new_value: any, old: any) {
        if (new_value && !this.progetto_model.data_fine) {
            this.progetto_model.data_fine = new_value
        }
    }

    @Watch('aziendeGruppoAutocomplete.selection')
    aziendeGruppo(new_value: any, old: any) {
        this.progetto_model.azienda_gruppo_id = new_value?.id || new_value
        this.clienteAutocomplete.addAjaxParam('azg', this.progetto_model.azienda_gruppo_id)
        this.committenteAutocomplete.addAjaxParam('azg', this.progetto_model.azienda_gruppo_id)

        if (new_value != old) {
            this.clienteAutocomplete.empty()
            this.committenteAutocomplete.empty()
        }
    }

    @Watch('visible')
    watchVisible() {
        if (this.visible && this.id) {
            this.loading = true
            progettiManager.progetto(this.id).then((res) => {
                this.progetto_model = {...this.progetto_model, ...res.data}
                this.sottoprogettoFiles = res.data.brief_files
                return this.aziendeGruppoAutocomplete.retrieve(this.progetto_model.azienda_gruppo_id)
            }).then(() => {
                Promise.all([
                    this.clienteAutocomplete.retrieve(this.progetto_model.cliente_id),
                    this.committenteAutocomplete.retrieve(this.progetto_model.committente_id),
                    progettiManager.contattiCliente(this.id).then((response) => {
                        this.contattiAutocomplete.options = response.data
                        this.contattiAutocomplete.selection = response.data
                    })
                ])
            }).then(() => {
                this.loading = false
            })
        }
    }


    creaProgetto() {
        this.loading = true
        this.setModelFile()
        if (this.create) {
            progettiManager.progettiCreate(this.progetto_model).then((res) => {
                this.$emit('saved', res.data)
            }).then(() => {
                this.empty()
            }).catch((res) => {
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
                this.alert_error = res.response.data.message
            }).finally(() => {
                this.loading = false
            })
        } else {
            progettiManager.progettiUpdate(this.id, this.progetto_model).then((res) => {
                this.$emit('saved', res.data)
            }).then(() => {
                this.empty()
            }).catch((res) => {
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
                this.alert_error = res.response.data.message
            }).finally(() => {
                this.loading = false
            })
        }
    }

    close() {
        this.$emit('update:visible', false)
        this.empty()
    }

    empty() {
        this.clienteAutocomplete.empty()
        this.aziendeGruppoAutocomplete.empty()
        this.committenteAutocomplete.empty()
        this.contattiAutocomplete.empty()
        this.progetto_model.titolo = null
        this.progetto_model.descrizione = null
        this.progetto_model.azienda_id = null
        this.progetto_model.committente_id = null
        this.progetto_model.azienda_gruppo_id = null
        this.progetto_model.data_inizio = null
        this.progetto_model.data_fine = null
        this.progetto_model.budget = null
        this.progetto_model.budget_presunto = null
        this.progetto_model.note = null
    }

    setModelFile() {
        this.progetto_model.brief_files = this.sottoprogettoFiles.map(e => e.id).concat(this.uploaded_files.map(e => e.id))
    }

    errors = {}

    getErrors(field: string) {
        return (this.errors as any)[field]
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
